import type { paths } from '@luxuryescapes/contract-cart'
import { isAccommodationV2Item, isBedbankItem, isFlightItem, isInstantBookingLEHotelItem, isLuxPlusSubscriptionItem } from 'lib/checkout/checkoutUtils'
import { ensureLuxPlusBenefitTitle } from 'lib/checkout/luxPlusSubscription/benefitMappers'

type AddItemsRequest = paths['/api/carts/multi-carts/{multiCartId}/items']['post']['requestBody']['content']['application/json']
export type MultiCartPayloadItem = AddItemsRequest['items'][number]

type MultiCartPayloadOccupancy = {
  roomId?: string
  adults: number
  children?: number
  infants?: number
  teenagers?: number
  childrenAge?: Array<number>
}

type AppOccupancy = MultiCartPayloadOccupancy & {
  id?: string
  childrenBirthDate?: Array<string | undefined>
}

export function mapOccupancyToMultiCartPayload(occupancy: AppOccupancy): MultiCartPayloadOccupancy {
  const { id, childrenBirthDate: _childrenBirthDate, ...payloadOccupancy } = occupancy

  return {
    ...payloadOccupancy,
    ...(id ? { roomId: id } : undefined),
  }
}

export function mapLuxPlusBenefitToCartPayload(
  benefit: App.OfferSubscriptionBenefitItem,
): App.OfferSubscriptionBenefitItem & { title: string } {
  return ensureLuxPlusBenefitTitle(benefit)
}

export function mapCheckoutItemToMultiCartPayloadItem(item: App.Checkout.AnyItem): MultiCartPayloadItem {
  if (isFlightItem(item) && !item.otherFees) {
    return {
      ...item,
      otherFees: {
        flightAtolFee: 0,
        flightBookingFee: 0,
        flightCreditFee: 0,
        flightServiceFee: 0,
      },
    } as MultiCartPayloadItem
  }

  if (isAccommodationV2Item(item)) {
    const { sessionId: _sessionId, occupancy, ...rest } = item
    return {
      ...rest,
      occupancy: mapOccupancyToMultiCartPayload(occupancy),
    } as MultiCartPayloadItem
  }

  if (isInstantBookingLEHotelItem(item) || isBedbankItem(item)) {
    return {
      ...item,
      occupancy: mapOccupancyToMultiCartPayload(item.occupancy),
    } as MultiCartPayloadItem
  }

  if (isLuxPlusSubscriptionItem(item)) {
    return {
      ...item,
      benefits: item.benefits.map(mapLuxPlusBenefitToCartPayload),
    } as MultiCartPayloadItem
  }

  return item as MultiCartPayloadItem
}
